var ColorsEnum = {
    "inherit": "var(--color-inherit)",
    "primary": "var(--primary)",
    "secondary": "var(--secondary)",
    "accent": "var(--accent)",
    "white": "var(--white)",
    "black": "var(--black)",
    "transparent": "var(--transparent)",
    "blue-0": "var(--blue-0)",
    "blue-1": "var(--blue-1)",
    "blue-2": "var(--blue-2)",
    "blue-3": "var(--blue-3)",
    "blue-4": "var(--blue-4)",
    "blue-5": "var(--blue-5)",
    "blue-6": "var(--blue-6)",
    "blue-7": "var(--blue-7)",
    "blue-8": "var(--blue-8)",
    "blue-9": "var(--blue-9)",
    "green-0": "var(--green-0)",
    "green-1": "var(--green-1)",
    "green-2": "var(--green-2)",
    "green-3": "var(--green-3)",
    "green-4": "var(--green-4)",
    "green-5": "var(--green-5)",
    "green-6": "var(--green-6)",
    "green-7": "var(--green-7)",
    "green-8": "var(--green-8)",
    "green-9": "var(--green-9)",
    "yellow-0": "var(--yellow-0)",
    "yellow-1": "var(--yellow-1)",
    "yellow-2": "var(--yellow-2)",
    "yellow-3": "var(--yellow-3)",
    "yellow-4": "var(--yellow-4)",
    "yellow-5": "var(--yellow-5)",
    "yellow-6": "var(--yellow-6)",
    "yellow-7": "var(--yellow-7)",
    "yellow-8": "var(--yellow-8)",
    "yellow-9": "var(--yellow-9)",
    "cyan-0": "var(--cyan-0)",
    "cyan-1": "var(--cyan-1)",
    "cyan-2": "var(--cyan-2)",
    "cyan-3": "var(--cyan-3)",
    "cyan-4": "var(--cyan-4)",
    "cyan-5": "var(--cyan-5)",
    "cyan-6": "var(--cyan-6)",
    "cyan-7": "var(--cyan-7)",
    "cyan-8": "var(--cyan-8)",
    "cyan-9": "var(--cyan-9)",
    "pink-0": "var(--pink-0)",
    "pink-1": "var(--pink-1)",
    "pink-2": "var(--pink-2)",
    "pink-3": "var(--pink-3)",
    "pink-4": "var(--pink-4)",
    "pink-5": "var(--pink-5)",
    "pink-6": "var(--pink-6)",
    "pink-7": "var(--pink-7)",
    "pink-8": "var(--pink-8)",
    "pink-9": "var(--pink-9)",
    "red-0": "var(--red-0)",
    "red-1": "var(--red-1)",
    "red-2": "var(--red-2)",
    "red-3": "var(--red-3)",
    "red-4": "var(--red-4)",
    "red-5": "var(--red-5)",
    "red-6": "var(--red-6)",
    "red-7": "var(--red-7)",
    "red-8": "var(--red-8)",
    "red-9": "var(--red-9)",
    "indigo-0": "var(--indigo-0)",
    "indigo-1": "var(--indigo-1)",
    "indigo-2": "var(--indigo-2)",
    "indigo-3": "var(--indigo-3)",
    "indigo-4": "var(--indigo-4)",
    "indigo-5": "var(--indigo-5)",
    "indigo-6": "var(--indigo-6)",
    "indigo-7": "var(--indigo-7)",
    "indigo-8": "var(--indigo-8)",
    "indigo-9": "var(--indigo-9)",
    "teal-0": "var(--teal-0)",
    "teal-1": "var(--teal-1)",
    "teal-2": "var(--teal-2)",
    "teal-3": "var(--teal-3)",
    "teal-4": "var(--teal-4)",
    "teal-5": "var(--teal-5)",
    "teal-6": "var(--teal-6)",
    "teal-7": "var(--teal-7)",
    "teal-8": "var(--teal-8)",
    "teal-9": "var(--teal-9)",
    "orange-0": "var(--orange-0)",
    "orange-1": "var(--orange-1)",
    "orange-2": "var(--orange-2)",
    "orange-3": "var(--orange-3)",
    "orange-4": "var(--orange-4)",
    "orange-5": "var(--orange-5)",
    "orange-6": "var(--orange-6)",
    "orange-7": "var(--orange-7)",
    "orange-8": "var(--orange-8)",
    "orange-9": "var(--orange-9)",
    "bluegray-0": "var(--bluegray-0)",
    "bluegray-1": "var(--bluegray-1)",
    "bluegray-2": "var(--bluegray-2)",
    "bluegray-3": "var(--bluegray-3)",
    "bluegray-4": "var(--bluegray-4)",
    "bluegray-5": "var(--bluegray-5)",
    "bluegray-6": "var(--bluegray-6)",
    "bluegray-7": "var(--bluegray-7)",
    "bluegray-8": "var(--bluegray-8)",
    "bluegray-9": "var(--bluegray-9)",
    "purple-0": "var(--purple-0)",
    "purple-1": "var(--purple-1)",
    "purple-2": "var(--purple-2)",
    "purple-3": "var(--purple-3)",
    "purple-4": "var(--purple-4)",
    "purple-5": "var(--purple-5)",
    "purple-6": "var(--purple-6)",
    "purple-7": "var(--purple-7)",
    "purple-8": "var(--purple-8)",
    "purple-9": "var(--purple-9)",
    "surface-0": "var(--surface-0)",
    "surface-1": "var(--surface-1)",
    "surface-2": "var(--surface-2)",
    "surface-3": "var(--surface-3)",
    "surface-4": "var(--surface-4)",
    "surface-5": "var(--surface-5)",
    "surface-6": "var(--surface-6)",
    "surface-7": "var(--surface-7)",
    "surface-8": "var(--surface-8)",
    "surface-9": "var(--surface-9)",
    "surface-10": "var(--surface-1)",
};
export var Colors = ColorsEnum;
